import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { exchangeSections } from 'data/exchanges';
import ExchangeSelectionTile, {
  EXCHANGE_SELECTION_ICON_SIZE_LG,
  EXCHANGE_SELECTION_TILE_SIZE_LG,
  getExchangeSelectionGridSx,
} from 'component/Exchanges/ExchangeSelectionTile';

const PurchaseLocationPills = ({
  id,
  name = 'exchange',
  label = 'Purchased at*',
  value,
  onChange,
}) => {
  const handleSelect = (nextValue) => {
    onChange({ target: { name, value: nextValue } });
  };

  const gridSx = getExchangeSelectionGridSx(EXCHANGE_SELECTION_TILE_SIZE_LG);

  return (
    <Box id={id} sx={{ mt: 2 }}>
      <Typography
        component="label"
        htmlFor={`${name}-tiles`}
        sx={{ color: '#fff', fontSize: 14, mb: 1, display: 'block', textAlign: 'center' }}
      >
        {label}
      </Typography>
      <input type="hidden" name={name} value={value || ''} />
      <Box
        id={`${name}-tiles`}
        role="radiogroup"
        aria-label={label}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25 }}
      >
        {exchangeSections.map(({ title, items }, index) => (
          <Box key={title} sx={{ width: '100%' }}>
            {index > 0 && (
              <Box
                sx={{
                  width: '100%',
                  height: '1px',
                  bgcolor: 'rgba(255,255,255,0.25)',
                  mb: 1.25,
                }}
              />
            )}
            <Box sx={gridSx}>
              {items.map((optionValue) => (
                <ExchangeSelectionTile
                  key={optionValue}
                  name={optionValue}
                  selected={value === optionValue}
                  onToggle={handleSelect}
                  inputRole="radio"
                  tileSize={EXCHANGE_SELECTION_TILE_SIZE_LG}
                  iconSize={EXCHANGE_SELECTION_ICON_SIZE_LG}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PurchaseLocationPills;
